import { ACTION, EXCHANGES, MODE } from "../broker/angelone/constant";

function heartbeat(that) {
  if (!that) {
    return
  }
  that.send("ping")
  /*clearTimeout(this.pingTimeout);

  // Use `WebSocket#terminate()`, which immediately destroys the connection,
  // instead of `WebSocket#close()`, which waits for the close timer.
  // Delay should be equal to the interval at which your server
  // sends out pings plus a conservative assumption of the latency.
  this.pingTimeout = setTimeout(() => {
    this.terminate();
  }, 30000 + 1000);*/
}

function onConnect(ws, setWebSocket) {
  console.log('connected');
  heartbeat(ws)

  setInterval(() => heartbeat(ws), 30000);
  setWebSocket(ws)
}

export function subscribeToWS(websocket, tokens) {
  if (!websocket || !tokens || tokens.length === 0) {
    console.log("No tokens specified")
    return
  }
  const request = {
    "action": ACTION.Subscribe,
    "params": {
      "mode": MODE.SnapQuote,
      "tokenList": [
        {
          "exchangeType": EXCHANGES.nse_cm,
          "tokens": tokens
        },
      ]
    }
  }
  console.log('WSS request', request)
  websocket.send(JSON.stringify(request));
}

const onError = function (event, clientCreds, setWebSocket, onMessage, retriesLeft) {
  console.log(`[error] Error received from server:`, event);
  if (retriesLeft > 0)
    connectToWS(clientCreds, setWebSocket, onMessage, retriesLeft - 1)
  else
    setWebSocket(null)
};
const onCloseDefault = function (event, setWebSocket) {
  console.log(`[close] Closing socket connections:`, event);
  setWebSocket(null)
};

export const connectToWS = (clientCreds, setWebSocket, onMessage, onClose = onCloseDefault, retriesLeft = 10) => {
  if (clientCreds === undefined || Object.keys(clientCreds).length === 0 || !clientCreds.clientCode) {
    return;
  }
  const ws = new WebSocket(`wss://smartapisocket.angelone.in/smart-stream?clientCode=${clientCreds.clientCode}&feedToken=${clientCreds.feedToken}&apiKey=${clientCreds.apiKey}`);
  ws.binaryType = "arraybuffer";

  ws.onopen = (() => onConnect(ws, setWebSocket));
  ws.onmessage = onMessage;
  ws.onerror = (e => onError(e, clientCreds, setWebSocket, onMessage, retriesLeft));
  ws.onclose = (e => onClose?.(e, setWebSocket));

  return ws;
}